import React from "react";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import PdfZipItem from "./PdfZipItem";
const ShowTable = ({ title, data }) => {
  const { getText } = useLanguageTranslation();
  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
      <div className="title-sec">
        <h2>
          {getText(
            "School, State and National Level Painting Competition for School Students",
            "स्कूल के छात्रों के लिए स्कूल, राज्य और राष्ट्रीय स्तर की चित्रकारी प्रतियोगिता"
          )}
        </h2>
        <div className="table-responsive">
          <table className="table table-striped custom-table">
            <thead className="thead-dark">
              <tr>
                <th>{getText("S.No.", "क्र. सं.")}</th>
                <th>{getText("Description", "विवरण")}</th>
                <th>{getText("Download", "डाउनलोड")}</th>
              </tr>
            </thead>
            <tbody>
              {data?.length === 0 ? (
                <tr>
                  <td colSpan={3}>No Data Available</td>
                </tr>
              ) : (
                data?.map((item, index) => (
                  <tr key={index}>
                    <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                    <td data-key={getText("Description", "विवरण")}>
                      {item?.title}
                    </td>
                    <td data-key={getText("Download", "डाउनलोड")}>
                      <PdfZipItem
                        filePath={item?.file_path}
                        filesize={item?.filesize}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ShowTable;
